module.exports = __webpack_public_path__ + "img/br.b2290d68.png";